var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-height: ${_vm.minHeight}`)},[(_vm.type === 'video')?_c('div',[(_vm.content.video.videohub_content)?_c('script',{ref:"player",attrs:{"data-videohub-id":_vm.content.video.videohub_content,"src":`https://evolucional.videohub.com.br/embed.js?${_vm.now}`,"type":"module"}}):_c('iframe',{staticClass:"top-0 bottom-0 w-100 h-100 left-0 right-0 h-100 border-0",style:(`
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                min-height: ${_vm.minHeight};
              `),attrs:{"src":_vm.videoContent}})]):_vm._e(),_vm._v(" "),(_vm.type === 'quiz')?_c('ModuleQuestionsComponent',{attrs:{"questions":_vm.content.quiz}}):_vm._e(),_vm._v(" "),(_vm.type === 'page')?_c('ModulePageComponent',{attrs:{"page":_vm.content.page}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }